import React, { useEffect } from 'react';
import { standards, ProcessButton } from '../../../../components';

function useButton(commands) {
  const sendOrder = (order, userId, basketItems, consumerSpaceData) => {
    const body = {
      offers: basketItems.map(({ id, amount }) => ({ id, amount })),
      delivery: {
        method: order.deliveryMethod,
        shift: order.deliveryShift,
        addressId: order.deliveryAddrId,
        date: order.deliveryDate,
      },
      payment: {
        method: order.paymentMethod,
      },
      userId,
      consumerId: consumerSpaceData ? consumerSpaceData.producerId : userId,
      consumerType: consumerSpaceData ? 'producer' : 'user',
    };
    const bodyWithDonation = order.donationValue ? { ...body, donationValue: order.donationValue } : body;
    commands.order.createOrder(bodyWithDonation, (res) => commands.order.changeDataAttribute('id', res.orderId));
  };

  const goToSuccess = () => {
    commands.basket.clear();
    commands.process.goToStep(7);
  };
  return ({
    eventHandlers: {
      sendOrder,
      goToSuccess,
    },
  });
}

export default function Button(props) {
  const {
    sharedStates, remoteStates, commands, metaStates,
  } = props;
  const {
    donation, order, userId, basketItems, consumerSpaceData,
  } = sharedStates;

  const { eventHandlers } = useButton(commands);

  useEffect(() => {
    if (metaStates.isCreated) eventHandlers.goToSuccess();
  }, [metaStates.isCreated]);

  return (
    <ProcessButton
      style={{
        backgroundColor: donation === undefined
          ? standards.colors.orange.medium
          : standards.colors.green.weak,
      }}
      text={donation === undefined
        ? 'Selecione sua doação'
        : metaStates.isCreating
          ? 'Enviando pedido...'
          : 'Finalizar pedido'}
      action={donation === undefined || metaStates.isCreating
        ? () => {}
        : () => eventHandlers.sendOrder(order, userId, basketItems, consumerSpaceData)}
    />

  );
}
